// LBX => Freshdesk
export default {
  mapLangs (lang) {
    const map = {
      'cs_CZ': 'cs',
      'da_DK': 'da',
      'de_DE': 'de',
      'en_US': 'en',
      'es_419': 'es-LA',
      'es_ES': 'es',
      'fr_FR': 'fr',
      'hu_HU': 'hu',
      'id_ID': 'id',
      'it_IT': 'it',
      'ms_MY': 'en',
      'nl_NL': 'nl',
      'pl_PL': 'pl',
      'pt_BR': 'pt-BR',
      'pt_PT': 'pt-PT',
      'ro_RO': 'ro',
      'ru_RU': 'ru-RU',
      'sk_SK': 'sk',
      'sv_SE': 'sv-SE',
      'tr_TR': 'tr',
      'uk_UA': 'uk',
      'zh_CN': 'zh-CN', // Chinese (Simple)
      'zh_HK': 'zh-TW' // Chinese (Traditional)
    }

    return map[lang] || map['en_US']
  },

  mapBroker: {
    '23000019614': 'CYPB',
    '23000019668': 'BLRD',
    '23000019669': 'FCIL',
    '23000019670': 'RUSD',
    '23000019671': 'XCOEX'
  },

  env: process.env.NODE_ENV === 'production'
    ? 'prod'
    : process.env.NODE_ENV === 'development'
      ? 'dev'
      : process.env.NODE_ENV === 'qa'
        ? 'QA'
        : undefined,

  // generic tealium tracker
  tealiumTrack (vm, obj) {
    // expecting obj as {page_type}
    const ua = navigator.userAgent
    const uid = vm.$uid ? vm.$uid[1] : 'unset'
    const pagePath = vm.$vnode.tag.split('-').pop()
    const pageBroker = this.mapBroker[vm.$categoryId]
    const lang = this.mapLangs(vm.$lang)

    const data2send = {
      product_name: 'view hdp page',
      product_subcategory: 'black',
      product_category: 'HDP',
      event_date: new Date().toISOString().slice(0, 19).replace('T', ' '),
      event_type: 'view',
      page_system: 'HDP',
      page_type: '',
      page_language: lang,
      page_environment: this.env,
      page_path: pagePath,
      page_broker: pageBroker,
      event_account_id: uid,
      customer_profile_id: uid,
      customer_profile_is_logged: uid,
      page_channel: ua.match(/iPhone|iPad|iPod/i) ? 'nmp_ios' : ua.match(/Android/i) ? 'nmp_android' : 'unknown'
    }

    Object.assign(data2send, obj)

    const tealiumWaiter = setInterval(function () {
      if (window.utag) {
        if (window.tealium && window.tealium.libertexInstance) {
          window.tealium.track('view', data2send, window.tealium.libertexInstance)
        } else {
          window.utag.view(data2send)
        }
        clearInterval(tealiumWaiter)
      }
    }, 250)
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js